/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice } from "@reduxjs/toolkit";
// import { InitialState } from "../interfaces/pricing.interfaces";
import { getPurchaseMapping } from "../actions/pricingDashboard.action";

const initialState: any = {};

const pricingPreviewSlice = createSlice({
  name: "Get Plans",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPurchaseMapping.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(getPurchaseMapping.fulfilled, (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    });

    builder.addCase(getPurchaseMapping.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export default pricingPreviewSlice.reducer;
